<div class="sg-headline" [style.background-image]="'url(' + backgroundUrl + ')'">
    <div class="sg-headline__shard">
        <div class="row sg-headline__shard__shade">
            <div class="col-sm-12 col-md-7 sg-headline__shard__shade__overlay"></div>
            <div class="d-none d-md-block col-md-3 col-xl-1 sg-headline__shard__shade__triangle d-sm-none"></div>
        </div>
    </div>

    <ng-content></ng-content>
</div>
